import React, { useEffect } from "react";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RegisterPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { signup, isAuthenticated, errors: registerErrors } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) navigate("/");
  }, [isAuthenticated, navigate]);

  const onSubmit = handleSubmit(async (values) => {
    await signup(values);
  });

  return (
    <Grid container sx={{ minHeight: "100vh", bgcolor: "#ECECEC" }}>
      {/* Columna izquierda: formulario */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 500,
            bgcolor: "#903AF2",
            color: "#fff",
            borderRadius: 4,
            boxShadow: 8,
          }}
        >
          <CardContent>
            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              sx={{ textAlign: "center" }}
            >
              Crear nueva cuenta
            </Typography>

            {/* Errores globales */}
            {registerErrors.length > 0 && (
              <Box mb={2}>
                {registerErrors.map((error, i) => (
                  <Alert key={i} severity="error" sx={{ mb: 1 }}>
                    {error}
                  </Alert>
                ))}
              </Box>
            )}

            {/* Formulario */}
            <form onSubmit={onSubmit} noValidate>
              <TextField
                fullWidth
                margin="normal"
                variant="filled"
                label="Nombre de usuario"
                {...register("username", {
                  required: "El nombre es requerido",
                })}
                error={!!errors.username}
                helperText={errors.username?.message}
                InputProps={{ style: { color: "#fff" } }}
                InputLabelProps={{ style: { color: "#fff" } }}
              />

              <TextField
                fullWidth
                margin="normal"
                variant="filled"
                label="Correo electrónico"
                type="email"
                {...register("email", {
                  required: "El correo es requerido",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Correo inválido",
                  },
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
                InputProps={{ style: { color: "#fff" } }}
                InputLabelProps={{ style: { color: "#fff" } }}
              />

              <TextField
                fullWidth
                margin="normal"
                variant="filled"
                label="Contraseña"
                type="password"
                {...register("password", {
                  required: "La contraseña es requerida",
                  minLength: {
                    value: 6,
                    message: "Mínimo 6 caracteres",
                  },
                })}
                error={!!errors.password}
                helperText={errors.password?.message}
                InputProps={{ style: { color: "#fff" } }}
                InputLabelProps={{ style: { color: "#fff" } }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  bgcolor: "#EAF7CF",
                  color: "#565254",
                  fontWeight: "bold",
                  "&:hover": { bgcolor: "#c9e2b1" },
                }}
              >
                Registrar cuenta
              </Button>
            </form>

            <Typography textAlign="center" mt={3}>
              ¿Ya tienes una cuenta?
              <Link to="/login" style={{ color: "#EE964B", marginLeft: 5 }}>
                Iniciar sesión
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Columna derecha: mensaje visual */}
      <Grid
        item
        xs={false}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#903AF2",
          color: "#ECECEC",
          textAlign: "center",
          p: 4,
        }}
      >
        <Box>
          <Typography variant="h4" fontWeight="bold" mb={2}>
            Empezá con Ubika
          </Typography>
          <Typography>
            Accedé a herramientas que optimizan tus reservas y hacé crecer tu
            alojamiento.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
